import DynamicCode from "!!raw-loader!./cssgrids/Dynamic.tsx";
import { styled } from "@mui/material/styles";
import Fixed1Code from "!!raw-loader!./cssgrids/Fixed1.tsx";
import Fixed4Code from "!!raw-loader!./cssgrids/Fixed4.tsx";
import { grey } from "designSystem/styles/color";
import React from "react";
import { ComponentProps } from "../Component";
import Pane, { paneComponent, PaneProps } from "../Pane";
import Dynamic from "./cssgrids/Dynamic";
import Fixed1 from "./cssgrids/Fixed1";
import Fixed4 from "./cssgrids/Fixed4";

const PREFIX = "CssGrids";

const classes = {
	box: `${PREFIX}box`,
};

const Root = styled("div")(({
	theme,
}) => ({
	[`& .${classes.box}`]: {
		backgroundColor: grey[50],
		maxHeight: 400,
		width: "auto",
	},
}));

export default (props: PaneProps) => {
	const { box } = classes;

	const components: ComponentProps[] = [
		paneComponent("1 Column", Fixed1Code, Fixed1, null, box),
		paneComponent("4 Columns", Fixed4Code, Fixed4, null, box),
		paneComponent("Dynamic Columns", DynamicCode, Dynamic, "Resize browser and number of columns will change based on the width", box),
	];

	return (
		<Root>
			<Pane
				components={components}
				imports='import {CssGrid} from "designSystem/index";'
				{...props}
			/>
		</Root>
	);
};
